import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class OrgCatalogs {
	async getOrgDivisionsTree(pgid: PGSchema.pages["id"], token?: string) {
		return xget<{ divisions: PGSchema.hcm_divisions[] }>(`/pages/${pgid}/org-divisions`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getDivisions(pgid: PGSchema.pages["id"], token?: string) {
		return xget<PGSchema.hcm_divisions[]>(`/pages/${pgid}/divisions`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async createDivision(pgid: PGSchema.pages["id"], data: { name: string; descrip?: string }, token?: string) {
		return xhttp<PGSchema.hcm_divisions>(`/pages/${pgid}/divisions`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async updateDivision(pgid: PGSchema.pages["id"], id: string, data: { name?: string; descrip?: string | null }, token?: string) {
		return xhttp<PGSchema.hcm_divisions>(`/pages/${pgid}/divisions/${id}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async deleteDivision(pgid: PGSchema.pages["id"], id: string, token?: string) {
		return xhttp<{ deleted: boolean }>(`/pages/${pgid}/divisions/${id}`, "DELETE", undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getTeams(pgid: PGSchema.pages["id"], params?: { division_id?: string }, token?: string) {
		return xget<PGSchema.hcm_teams[]>(`/pages/${pgid}/teams`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async createTeam(pgid: PGSchema.pages["id"], data: { division_id: string; name: string; descrip?: string }, token?: string) {
		return xhttp<PGSchema.hcm_teams>(`/pages/${pgid}/teams`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async updateTeam(pgid: PGSchema.pages["id"], id: string, data: { name?: string; descrip?: string | null; division_id?: string }, token?: string) {
		return xhttp<PGSchema.hcm_teams>(`/pages/${pgid}/teams/${id}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async deleteTeam(pgid: PGSchema.pages["id"], id: string, token?: string) {
		return xhttp<{ deleted: boolean }>(`/pages/${pgid}/teams/${id}`, "DELETE", undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getRoles(pgid: PGSchema.pages["id"], params?: { team_id?: string }, token?: string) {
		return xget<PGSchema.hcm_roles[]>(`/pages/${pgid}/roles`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async createRole(pgid: PGSchema.pages["id"], data: { team_id: string; name: string; descrip?: string }, token?: string) {
		return xhttp<PGSchema.hcm_roles>(`/pages/${pgid}/roles`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async updateRole(pgid: PGSchema.pages["id"], id: string, data: { name?: string; descrip?: string | null; team_id?: string }, token?: string) {
		return xhttp<PGSchema.hcm_roles>(`/pages/${pgid}/roles/${id}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async deleteRole(pgid: PGSchema.pages["id"], id: string, token?: string) {
		return xhttp<{ deleted: boolean }>(`/pages/${pgid}/roles/${id}`, "DELETE", undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getRoleLevels(pgid: PGSchema.pages["id"], params?: { role_id?: string }, token?: string) {
		return xget<PGSchema.hcm_role_levels[]>(`/pages/${pgid}/role-levels`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async createRoleLevel(pgid: PGSchema.pages["id"], data: { role_id: string; name: string; descrip?: string; salary_cents_min?: number; salary_cents_max?: number; aptitudes?: { name: string; descrip: string }[] }, token?: string) {
		return xhttp<PGSchema.hcm_role_levels>(`/pages/${pgid}/role-levels`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async updateRoleLevel(
		pgid: PGSchema.pages["id"],
		id: string,
		data: { name?: string; descrip?: string | null; role_id?: string; salary_cents_min?: number | null; salary_cents_max?: number | null; aptitudes?: { name: string; descrip: string }[] },
		token?: string
	) {
		return xhttp<PGSchema.hcm_role_levels>(`/pages/${pgid}/role-levels/${id}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}
	async deleteRoleLevel(pgid: PGSchema.pages["id"], id: string, token?: string) {
		return xhttp<{ deleted: boolean }>(`/pages/${pgid}/role-levels/${id}`, "DELETE", undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}
}
